<div *ngIf="form">
  <button mat-raised-button color="sims" (click)="new()" *ngIf="showAddButton && allowCreateNew && !hideTopAddButton" class="mb-3">
    {{ addNewText | translate }}
  </button>

  <h3 *ngIf="showAddButton && allowCreateNew">{{ editModeText | translate }}</h3>
  <h3 *ngIf="!showAddButton && allowCreateNew">{{ addModeText | translate }}</h3>

  <form [formGroup]="form">
    <ng-container *ngFor="let formField of formFieldElements">
      <ng-container [ngSwitch]="formField.fieldType">

        <input *ngSwitchCase="'hidden'" type="hidden" [formControlName]="formField.name">

        <mat-form-field *ngSwitchCase="'input'">
          <mat-label>
            {{ formField.textName || formField.name | translate }}
          </mat-label>
          <ng-container *ngIf="isTextarea(formField); else input">
            <textarea
              matInput
              cdkTextareaAutosize
              [cdkAutosizeMinRows]="getMinRows(formField)"
              [cdkAutosizeMaxRows]="getMaxRows(formField)"
              [class.preset-description]="formField.formFieldType === 'resizing-area'"
              [formControlName]="formField.name"
              [pattern]="formField.pattern"
              [minlength]="formField.minLength"
              [maxlength]="formField.maxLength"
              [min]="formField.min"
              [max]="formField.max"
              [step]="formField.step"
              [value]="formField.defaultValue | translate">
            </textarea>
          </ng-container>

          <ng-template #input>
            <input matInput [formControlName]="formField.name" [type]="formField.formFieldType" [pattern]="formField.pattern"
                 [minlength]="formField.minLength" [maxlength]="formField.maxLength" [min]="formField.min" [max]="formField.max" 
                 [step]="formField.step" [value]="formField.defaultValue | translate">
            </ng-template>
          <mat-error [appMatErrorMessages]="formField.validators"></mat-error>
        </mat-form-field>

        <mat-form-field *ngSwitchCase="'select'">
          <mat-label>
            {{ formField.textName || formField.name | translate }}
          </mat-label>
          <mat-select [formControlName]="formField.name">
            <mat-option *ngFor="let option of formField.options" [value]="option.key" [disabled]="option.disabled">
              {{ translateOptions ? (option.value | translate) : option.value }}
            </mat-option>
          </mat-select>
          <mat-error [appMatErrorMessages]="formField.validators"></mat-error>
        </mat-form-field>

        <mat-form-field *ngSwitchCase="'multi-select'">
          <mat-label>
            {{ formField.textName || formField.name | translate }}
          </mat-label>
          <mat-select [formControlName]="formField.name" multiple>
            <mat-option *ngFor="let option of formField.options" [value]="option.key" [disabled]="option.disabled">
              {{ translateOptions ? (option.value | translate) : option.value }}
            </mat-option>
          </mat-select>
          <mat-error [appMatErrorMessages]="formField.validators"></mat-error>
        </mat-form-field>

        <mat-form-field *ngSwitchCase="'multi-select-all'">
          <mat-label>
            {{ formField.textName || formField.name | translate }}
          </mat-label>
          <mat-select [formControlName]="formField.name" multiple>
            <app-select-check-all [model]="form.get(formField.name)" [values]="getOptionValues(formField.options)"></app-select-check-all>
            <mat-option *ngFor="let option of formField.options" [value]="option.key" [disabled]="option.disabled">
              {{ translateOptions ? (option.value | translate) : option.value }}
            </mat-option>
          </mat-select>
          <mat-error [appMatErrorMessages]="formField.validators"></mat-error>
        </mat-form-field>
        <app-autocomplete *ngSwitchCase="'autocomplete'"
          [parentForm]="form"
          [controlName]="formField.name"
          [options]="formField.options"
          [label]="formField.name"
          [validators]="formField.validators">
        </app-autocomplete>

        <div *ngSwitchCase="'checkbox'" class="pt-3 pb-3">
          <mat-checkbox [formControlName]="formField.name">{{ formField.textName || formField.name | translate }}</mat-checkbox>
        </div>

      </ng-container>
    </ng-container>

    <div *ngIf="showAddButton || (!showAddButton && allowCreateNew)" fxLayout="row" fxLayoutAlign="space-between" class="mt-3">
      <button mat-raised-button color="sims" type="button" (click)="save()" [disabled]="!form.valid">{{ 'save' | translate }}</button>
      <button mat-raised-button color="sims" type="button" *ngIf="showCancel" (click)="cancelled.emit()">{{ 'cancel' | translate }}</button>
    </div>
  </form>
</div>